import "./App.css";
import { Toaster } from "sonner";
import Header from "./components/atlas/Header";
import Hero from "./components/atlas/Hero";
import Services from "./components/atlas/Services";
import WhyChooseUs from "./components/atlas/WhyChooseUs";
import Process from "./components/atlas/Process";
import FAQ from "./components/atlas/FAQ";
import Contact from "./components/atlas/Contact";
import Footer from "./components/atlas/Footer";
import FloatingActions from "./components/atlas/FloatingActions";

function App() {
  return (
    <div className="App">
      <Toaster position="bottom-right" richColors />
      <Header />
      <main>
        <Hero />
        <Services />
        <WhyChooseUs />
        <Process />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
}

export default App;
